<template>
  <div>
    <v-text-field label="Policy" v-model="policies.policy"></v-text-field>
    <v-text-field label="URL" v-model="policies.policy_link"></v-text-field>
    <div style="text-align: right;">
      <v-btn color="info" small type="submit" @click="createPolicy"
        >Submit</v-btn
      >
    </div>
  </div>
</template>

<script>
import APIPolicies from "@/mixins/APIPolicies";
export default {
  components: {},
  mixins: [APIPolicies],
  data() {
    return {
      policies: {
        policy: ""
      },
      email: "",
      rules: {
        required: value => !!value || "Required.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  computed: {
    queriedUrlId() {
      let url = window.location.href.split("create/");
      return url[1];
    }
  },
  watch: {},
  created() {
    this.restoreFrom();
  },
  methods: {
    restoreFrom: async function() {
      if (this.$route.params.object !== undefined) {
        this.policies = this.$route.params.object;
      } else if (
        this.$route.params.object === undefined &&
        this.queriedUrlId !== "0"
      ) {
        try {
          this.policies = await this.gePolicieById(this.queriedUrlId);
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", {
            position: "topCenter"
          });
        }
      }
    }
  }
};
</script>
